// Interfaces
import { ISideTreeContent } from "../interfaces";

// Components
import SideTreeCustomComponent from "../TreeBasicsComponents/SideTreeCustomComponent";
import SideTreeLabel from "../TreeBasicsComponents/SideTreeLabel";
import SideTreeTooltip from "../TreeBasicsComponents/SideTreeTooltip";

export default function SideTreeContent(props: Readonly<ISideTreeContent>) {
	const { tooltip = null, customComponent = null, title = "" } = props;

	if (customComponent) {
		return <SideTreeCustomComponent title={props?.title ?? ""} {...props} {...customComponent} />;
	}

	if (tooltip) {
		return <SideTreeTooltip {...props} />;
	}

	return <SideTreeLabel {...props} title={title} />;
}
